// Purchase order UOM cell: use totalQty.
export const getPurchaseOrderUomQty = (summary) =>
  summary && summary.totalQty != null ? summary.totalQty : 0;

// Purchase order All column: sum totalQty for this productId across summaries.
export const getPurchaseOrderProductAllQty = (
  product,
  uomList,
  orderSummaries
) =>
  (orderSummaries || [])
    .filter((row) => row.productId === product.id)
    .reduce((sum, row) => sum + (row.totalQty || 0), 0);
